// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);
// Create the root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/docapp">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
